<template>
  <slot></slot>
</template>

<script setup>
</script>